import React from "react";
import BackIcon from "./BackIcon";
import "./StaticHeader.scss";

export const StaticHeader = (props) => {
  const { title, backurl } = props.data;
  //console.log("Header:", props, title, backurl);
  return (
    <>
      <header className="header">
        {backurl != null && backurl !== "" && (
          <div
            className="backurl"
            onClick={() => {
              window.location.href = backurl;
            }}
          >
            <BackIcon />
          </div>
        )}
        <div className="title">{title == null ? "SIGN IN" : title}</div>
        {backurl != null && backurl !== "" && <div className="backurl"></div>}
      </header>
    </>
  );
};

export default StaticHeader;
